import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
import { ALL_PIPELINES_QUERY_PARAM, DEAL_OBJECT_ID } from '../constants/CrmSearchConstants';
const getBaseUrl = () => '/forecasting';
export const getRootUrl = () => `${getBaseUrl()}/${PortalIdParser.get()}`;
export function getHubspotBaseUrl() {
  return getFullUrl('app');
}
const portalId = PortalIdParser.get();
const baseAppURL = getHubspotBaseUrl();

// TODO #2645: Differences between Overview Table "N Deals" and Deals App Results List
export const getFilteredDealsUrl = (filterGroups, pipelineQuery) => {
  const filterQuery = filterGroups.length && JSON.stringify(filterGroups[0].filters);
  if (!pipelineQuery) {
    return encodeURI(`${baseAppURL}/contacts/${portalId}/objects/0-3/views/forecast/list/?filters=${filterQuery}`);
  }
  return encodeURI(`${baseAppURL}/contacts/${portalId}/objects/0-3/views/forecast/list/?filters=${filterQuery}&pipelineId=${pipelineQuery}`);
};
export const createNewGoalsUrl = () => encodeURI(`${baseAppURL}/goals/${portalId}/create/1?goalType=sales_quota&redirectUrl=${baseAppURL}/forecasting/${portalId}`);
export const createLinkFromDealId = id => {
  return `/contacts/${PortalIdParser.get()}/record/${DEAL_OBJECT_ID}/${id}/`;
};
export const getReturnLink = (currentPathname, currentSearch, linkTo) => {
  const eschref = `eschref=${encodeURIComponent(`${currentPathname}${currentSearch}`)}`;
  const qsIndex = linkTo.indexOf('?');
  if (qsIndex === -1) {
    return `${linkTo}?${eschref}`;
  }
  return `${linkTo}&${eschref}`;
};

// Computes `pipeline` query param for linking to the Deals App's Forecasting View
// - If all (or multiple) pipelines are selected, we need to use the "all" query parameter to set
//   the pipeline dropdown in the Deals App's Forecasting View to "All Pipelines"
// - The encoded filter query param (from getFilteredDealsUrl) will then apply "Advanced Filters" to scope to the selected pipelines
export const computePipelineQueryParam = (isAllPipelinesSelected, selectedPipelines) => {
  if (!(selectedPipelines !== null && selectedPipelines !== void 0 && selectedPipelines.length)) {
    return undefined;
  }
  return isAllPipelinesSelected || selectedPipelines.length > 1 ? ALL_PIPELINES_QUERY_PARAM : selectedPipelines[0];
};